(() => {
  if (customElements.get('product-form')) return;

  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    getSelectedVariantInput() {
      return (
        document.querySelector(
          `#ProductSelector-${this.dataset.sectionId} input[name="id"]`
        ) ||
        document.querySelector(
          `product-selector[data-section-id="${this.dataset.sectionId}"] input[name="id"]`
        )
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const purchaseOptions = document.querySelector('purchase-options');

      if (
        purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      if (this.submitButton) {
        this.submitButton.classList.add('disabled');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      /*
       * İkinci güvenlik katmanı:
       * Sepete ekleme anında güncel 6 / 7 / 8 mm varyant ID'sini
       * doğrudan ürün seçicisinden alıp form verisine yazar.
       */
      const selectedVariantInput = this.getSelectedVariantInput();

      if (selectedVariantInput?.value) {
        formData.set('id', selectedVariantInput.value);
      }

      if (
        this.cartDrawer &&
        typeof this.cartDrawer.getSectionsToRender === 'function'
      ) {
        formData.append(
          'sections',
          this.cartDrawer
            .getSectionsToRender()
            .map(section => section.section)
        );

        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (
            this.cartDrawer &&
            typeof this.cartDrawer.renderContents === 'function'
          ) {
            this.cartDrawer.renderContents(response);
          } else {
            window.location.href = routes.cart_url;
          }
        })
        .catch(error => {
          console.error('Kairos sepete ekleme hatası:', error);
          this.handleErrorMessage(
            'Ürün sepete eklenemedi. Lütfen tekrar deneyin.'
          );
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('disabled');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
    }

    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (!submitButton) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');

          if (text) {
            submitButton.textContent = text;
          }
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();
